import { Injectable } from '@angular/core';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    // Configura los gestos que quieres habilitar o deshabilitar
    pinch: { enable: false },
    rotate: { enable: false }
  };
}